import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  MAINTENANCE_FAIL_MODE_PATH,
  NEW_MAINTENANCE_FAIL_MODE_PATH,
} from '../../../../config/paths';
import {
  getMaintenanceFailModes,
  clearMaintenanceFailModes,
} from '../../../../actions/mechanical-maintenance';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { MAINTENANCE_FAIL_MODE_COLUMNS } from '../../../../config/columns';

export const MaintenanceFailModes = ({
  breadcrumbs,
  maintenanceFailModes,
  loading,
  dispatchGetActivities,
  dispatchClearActivities,
}) => {
  useLayoutEffect(() => () => dispatchClearActivities(), []);

  const data = maintenanceFailModes.get('content') || [];
  const pages = maintenanceFailModes.get('totalPages') || null;
  const defaultPageSize = maintenanceFailModes.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Modos de Fallo de Mantenimiento"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_MAINTENANCE_FAIL_MODE_PATH}
      tableStructure={{
        columns: MAINTENANCE_FAIL_MODE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetActivities,
        modelPath: MAINTENANCE_FAIL_MODE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetActivities: getMaintenanceFailModes,
  dispatchClearActivities: clearMaintenanceFailModes,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Modos de Fallo de Mantenimiento',
      href: MAINTENANCE_FAIL_MODE_PATH,
    },
  ],
  maintenanceFailModes: MechanicalMaintenanceUnit.MaintenanceFailMode.getIn([
    'all',
    'content',
  ]),
  loading: MechanicalMaintenanceUnit.MaintenanceFailMode.getIn([
    'all',
    'loading',
  ]),
});

MaintenanceFailModes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  maintenanceFailModes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetActivities: PropTypes.func.isRequired,
  dispatchClearActivities: PropTypes.func.isRequired,
};

MaintenanceFailModes.defaultProps = {
  maintenanceFailModes: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaintenanceFailModes);
